import I18n from '@/global-components/i18n/i18n.vue'
import I18nFlags from '@/global-components/i18n/i18n-flags.vue'
import I18nToggleNew from '@/global-components/i18n/i18n-toggle-new.vue'

import Pagination from '@/global-components/pagination/pagination.vue'
import Chart from './chart/Main.vue'
import GoogleMapLoader from './google-map-loader/Main.vue'
import Highlight from './highlight/Main.vue'
import Litepicker from './litepicker/Main.vue'
import Tippy from './tippy/Main.vue'
import TippyContent from './tippy-content/Main.vue'
import TomSelect from './tom-select/Main.vue'
import LoadingIcon from './loading-icon/Main.vue'
import EpicSpinners from './epic-spinners/Main.vue'
import TinySlider from './tiny-slider/Main.vue'
import CKEditor from './ckeditor/Main.vue'
import Dropzone from './dropzone/Main.vue'
import FullCalendar from './calendar/Main.vue'
import FullCalendarDraggable from './calendar/Draggable.vue'

import ErrorNotify from '@/global-components/toastify-notify/error-notify.vue'
import SuccessNotify from '@/global-components/toastify-notify/success-notify.vue'
import SuccessNotifyWithButtons from '@/global-components/toastify-notify/success-notify-with-buttons.vue'
import AppButton from '@/global-components/button/AppButton.vue'
import toggleButton from '@/global-components/button/toggle-button.vue'

import ActionPrintButton from '@/global-components/actions-button/action-print-button.vue'
import ActionExportButton from '@/global-components/actions-button/action-export-button.vue'
import TableFilter from '@/global-components/filters/table-filter.vue'
import ListItemImage from '@/global-components/list/list-item-image.vue'
import ShowDateTime from '@/global-components/show-date-time.vue'
import EmptyPage from '@/global-components/empty-page.vue'
import AutoComplete from '@/global-components/auto-complete.vue'
import accordion from '@/global-components/accordion/accordion.vue'

import * as featherIcons from '@zhuowenli/vue-feather-icons'
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'
import VueQRCodeComponent from 'vue-qrcode-component'
import Autocomplete from 'vue3-autocomplete'
import 'vue3-autocomplete/dist/vue3-autocomplete.css' // Optional: Import default CSS
import Uploader from '@/global-components/uploader/uploader.vue'
import toggle from '@/global-components/toggle/toggle.vue'
import DiscountInput from '@/global-components/inputs/discount-input/discount-input.vue'

// Register the Vue component
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default app => {
  app.component([I18n.name], I18n)
  app.component('Uploader', Uploader)
  app.component('I18nFlags', I18nFlags)
  app.component([I18nToggleNew.name], I18nToggleNew)
  app.component('Pagination', Pagination)
  app.component('Chart', Chart)
  app.component('GoogleMapLoader', GoogleMapLoader)
  app.component('Highlight', Highlight)
  app.component('accordion', accordion)
  app.component('toggle', toggle)
  app.component('Litepicker', Litepicker)
  app.component('Tippy', Tippy)
  app.component('TippyContent', TippyContent)
  app.component('TomSelect', TomSelect)
  app.component('LoadingIcon', LoadingIcon)
  app.component('TinySlider', TinySlider)
  app.component('Dropzone', Dropzone)
  app.component('CKEditor', CKEditor)
  app.component('FullCalendar', FullCalendar)
  app.component('FullCalendarDraggable', FullCalendarDraggable)
  app.component('ErrorNotify', ErrorNotify)
  app.component('SuccessNotify', SuccessNotify)
  app.component('SuccessNotifyWithButtons', SuccessNotifyWithButtons)
  app.component('loading-spinner', EpicSpinners)
  app.component('AppButton', AppButton)
  app.component([toggleButton.name], toggleButton)
  app.component([ActionExportButton.name], ActionExportButton)
  app.component([ActionPrintButton.name], ActionPrintButton)
  app.component('TableFilter', TableFilter)
  app.component([ListItemImage.name], ListItemImage)
  app.component([ShowDateTime.name], ShowDateTime)
  app.component([EmptyPage.name], EmptyPage)
  app.component([AutoComplete.name], AutoComplete)
  app.component('font-awesome-icon', FontAwesomeIcon)
  app.component('qr-code', VueQRCodeComponent)
  app.component('Autocomplete', Autocomplete)
  app.component('discount-input', DiscountInput)

  app.use(VueTelInput)

  for (const [key, icon] of Object.entries(featherIcons)) {
    icon.props.size.default = '24'
    app.component(key, icon)
  }
}
